













































































import Vue from 'vue'

export default {
  name: 'password-modal',
  components: {
  },
  data() {
    return {
      email: undefined,
      password1: undefined,
      password2: undefined,
      showPassword: false,
      error: false,
      loading: false,
      success: false
    }
  },
  mounted() {
  },
  methods: {
    close() {
      if (document.location.hash === '#/password') document.location.hash = '#/'
      this.$store.dispatch('runtime/closeModal')
    },
    changePassword() {
      if (!this.passwordOk) return
      this.loading = true
      this.error = false
      const email = this.contributor ? this.contributorEmail : this.email
      const lang = this.$store.state.persistent.lang
      Vue.http.post(Vue.config.server + '/api/user/password', { email, password: this.password1, lang })
      .then(response => {
        this.success = true
      })
      .catch(response => {
        this.error = true
      })
      .finally(() => {
        this.loading = false
      })
    },
    togglePassword() {
      this.showPassword = !this.showPassword
    }
  },
  computed: {
    contributor() {
      return this.$store.getters['auth/isContributor']
    },
    contributorEmail() {
      return this.$store.getters['auth/email']
    },
    passwordOk() {
      if (!this.password1 || !this.password2) return null
      return (this.password1 === this.password2)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/password.vue